import sharingOptionTypes from 'helpers/enums/activities/sharing/sharingOptionTypes'

export default {
	[sharingOptionTypes.SOLUTION]: 'emptyPayload',
	[sharingOptionTypes.SUBMISSION]: 'participantSubmissionPayload',
}
